import { SkeletonLoader } from '@/components/shared/SkeletonLoader';
import { EmployeeAvatar } from '@/pages/home/present/EmployeeAvatar';
import { EmployeeStatus } from '@/pages/home/present/EmployeePresenceCard';
import { useGetMeQuery, useGetMyOpenWorkRecordsQuery } from '@/services/gql/graphql.generated';
import { FC, Suspense } from 'react';
import { Breadcrumbs, NavPage } from '../../../components/page/Breadcrumbs';
import { PageSizer, SizerMode } from '../../../components/page/PageSizer';
import strings from '../ess.translations';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';

const MyProfileHeaderContent: FC = () => {
  const [{ data: myData }] = useGetMeQuery();
  const [{ data: myOpenRecordsData }] = useGetMyOpenWorkRecordsQuery();
  const navigate = useNavigate();

  const myOpenRecords = myOpenRecordsData?.getMyOpenWorkTimeRecord;
  const onShift = myOpenRecords && myOpenRecords?.length > 0;

  return (
    <>
      <div className={'flex flex-col md:flex-row justify-between lg:relative'}>
        <div className="flex flex-row items-center text-3xl font-semibold">
          <button onClick={() => navigate(-1)}>
            <FiChevronLeft className="w-8 h-8" />
          </button>
          <div className="ml-2 mr-4">
            <EmployeeAvatar
              size={40}
              employee={{
                firstName: myData?.myEmployee?.firstName ?? '',
                lastName: myData?.myEmployee?.lastName ?? '',
                avatarUrl: myData?.myEmployee?.avatarUrl ?? undefined,
                status: onShift ? EmployeeStatus.ON_SHIFT : EmployeeStatus.NOT_ON_SHIFT,
                id: myData?.myEmployee?.employeeId || ''
              }}
            />
          </div>
          <div>
            <p>{strings.myProfile.header}</p>
          </div>
        </div>
      </div>
    </>
  );
};

const MyProfileHeaderContentSkeleton: FC = () => {
  return (
    <div className={'flex flex-col md:flex-row justify-between md:items-center'}>
      <div className="flex flex-row gap-8 items-center text-4xl font-bold">
        <EmployeeAvatar
          employee={{
            firstName: '',
            lastName: '',
            status: EmployeeStatus.NOT_ON_SHIFT,
            id: ''
          }}
          fetching={true}
        />
        <div>
          <SkeletonLoader className="w-[150px] h-10" />
        </div>
      </div>
    </div>
  );
};

export const MyProfileHeader: FC = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: strings.myProfile.header,
      to: `/ess/my-profile`
    }
  ];

  return (
    <div className={'w-full bg-secondary-std border-primary-std border-b'}>
      <PageSizer mode={SizerMode.HEADER}>
        <Breadcrumbs pages={breadcrumbs} />
        <Suspense fallback={<MyProfileHeaderContentSkeleton />}>
          <MyProfileHeaderContent />
        </Suspense>
      </PageSizer>
    </div>
  );
};
